export default __webpack_public_path__ + "static/media/2fa.888f091f.svg";